import { useAsync } from 'libs/uikit/lib';
import React from 'react';
import { PortalOutlet } from 'services/web/react/src/NgPortal/NgPortalOutlet';

const scriptmap = new Map<string, Promise<void>>();

export function loadScriptOnce(src: string): Promise<void> {
  if (scriptmap.has(src)) {
    return scriptmap.get(src)!;
  }

  const promise = new Promise<void>((resolve, reject) => {
    // create a script element
    const script = document.createElement('script');

    // set the script element src
    script.src = src;

    // listen for load/error events
    script.addEventListener('load', () => {
      resolve();
    });

    script.addEventListener('error', () => {
      reject();
    });

    document.head.appendChild(script);
  });

  scriptmap.set(src, promise);

  return promise;
}

const cssmap = new Map<string, Promise<void>>();

export async function loadCssOnce(...srcs: string[]): Promise<void> {
  await Promise.all(
    srcs.map((src) => {
      if (cssmap.has(src)) {
        return cssmap.get(src)!;
      }

      const promise = new Promise<void>((resolve, reject) => {
        // create a script element
        const stylesheet = document.createElement('link');

        // set the script element src
        stylesheet.rel = 'stylesheet';
        stylesheet.href = src;

        // listen for load/error events
        stylesheet.addEventListener('load', () => {
          resolve();
        });

        stylesheet.addEventListener('error', () => {
          reject();
        });

        document.head.appendChild(stylesheet);
      });

      scriptmap.set(src, promise);

      return promise;
    })
  );
}

interface NgBootstrapProps {
  entrypoint: () => Promise<EntrypointModule>;
}

interface EntrypointModule {
  bootstrap: () => void;
}

export function NgBootstrap(props: NgBootstrapProps) {
  useAsync(async () => {
    await props
      .entrypoint()
      .then((mod) => mod.bootstrap())
      .catch(console.error);
  }, []);

  return <PortalOutlet />;
}
